import { Controller } from "@hotwired/stimulus";
import gsap from "gsap";

export default class extends Controller {
  static targets = ["front", "back"];

  static values = {
    count: Number,
  };

  connect() {
    // const size = gsap.utils.random(1, 3, 0);
    requestAnimationFrame(() => {
      this.createSnow(this.frontTarget, this.countValue / 2, 4, 8);
      this.createSnow(this.backTarget, this.countValue / 2, 8, 12);
    });
  }

  createSnow(container, amount, minSpeed, maxSpeed) {
    let created = 0;

    const createBatch = () => {
      for (let i = 0; i < 3 && created < amount; i++, created++) {
        const flake = document.createElement("div");

        flake.classList.add("snowflake");
        const size = gsap.utils.random(1, 3, 0);
        flake.style.width = `${size}px`;
        flake.style.height = `${size}px`;

        container.appendChild(flake);

        this.animateFlake(flake, minSpeed, maxSpeed);
      }

      if (created < amount) {
        requestAnimationFrame(createBatch);
      }
    };

    createBatch();
  }

  animateFlake(flake, minSpeed, maxSpeed) {
    const duration = gsap.utils.random(minSpeed, maxSpeed);

    gsap.set(flake, {
      left: gsap.utils.random(0, 180),
      top: gsap.utils.random(-300, 0),
    });

    gsap.to(flake, {
      y: 330,
      duration,
      ease: "none",
      repeat: -1,
      modifiers: {
        y: (value) => {
          if (parseFloat(value) >= 330) {
            return `${gsap.utils.random(-300, -20)}px`;
          }

          return value;
        },
      },
    });

    gsap.to(flake, {
      x: gsap.utils.random(-30, 30),
      duration: duration / 2,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
    });
  }
  disconnect() {
    gsap.killTweensOf(this.frontTarget.querySelectorAll(".snowflake"));
    gsap.killTweensOf(this.backTarget.querySelectorAll(".snowflake"));

    this.frontTarget.replaceChildren();
    this.backTarget.replaceChildren();
  }
}
